import { styled, CircularProgress } from '@mui/material';

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  color: 'background.main',
}));
